// extracted by mini-css-extract-plugin
export default {"layoutBG":"SharedLayout_layoutBG__H4-14"};